<template>
  <b-dropdown
    block
    :text="selected.name"
    class="dropdown--dropselect form-control"
    variant="dropselect"
    ref="projectdropdown"
  >
    <b-dropdown-form v-if="searchable" class="dropdown-search">
      <b-form-input v-model="filterByName" :placeholder="$gettext('Search by name...')" class="form-control" />
      <font-awesome-icon v-if="filterByName != ''" @click.stop="clearSearch" icon="fa-solid fa-circle-xmark" class="reset-filter" />
    </b-dropdown-form>
    <b-dropdown-divider v-if="searchable" />
    <div class="option-list-wrap">
      <overlay-scrollbars :options="scrollBarsOptions" ref="dropselectScrollBar" class="dropselect-scrollbar">
        <b-dropdown-group v-if="projectsFiltered.length > 0" class="option-list">
          <b-dropdown-item 
            v-if="allowNull && selected.id"
            class="list-item"
            @click="selectOption(notSelectedItem)"
          >
            {{ notSelectedItem.name }}
          </b-dropdown-item>
          <b-dropdown-item 
            v-for="item in projectsFiltered" :key="item.id"
            class="list-item"
            @click="selectOption(item)"
          >
            {{ item.name }}
          </b-dropdown-item>
        </b-dropdown-group>
        <b-dropdown-group v-else class="option-list">
          <b-dropdown-item v-if="searchable && allowAdd" @click="() => { $emit('add-project', filterByName) }" class="list-item">
            <font-awesome-icon icon="fa-solid fa-plus" class="project-icon text-primary" />
            <span class="text-primary pr-1">{{ $gettext('Add') }}</span> <span>{{ filterByName }}</span>
          </b-dropdown-item>
          <b-dropdown-item v-else class="list-item">{{ $gettext('No results found') }}</b-dropdown-item>
        </b-dropdown-group>
      </overlay-scrollbars>
    </div>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import ProjectService from "@/store/services/project.service.js";
import GekkoButton from "@/components/GekkoButton";
export default {
  name: "ProjectSelect",
  components: { GekkoButton },
  props: {
    customerId: {
      type: Number,
      default: null
    },
    preselect: {
      type: Number,
      default: null
    },
    searchable: {
      type: Boolean,
      default: false
    },
    allowAdd: {
      type: Boolean,
      default: false
    },
    allowNull: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      options: [],
      projectsList: [],
      filterByName: '',
      notSelectedItem: {
        name: this.$gettext('Select project'),
        id: null
      },
      selected: {
        name: '',
        id: null
      },
      filters: {
        is_archived: 'False',
        extended: 'True'
      },
      scrollBarsOptions: {
        scrollbars: { autoHide: 'never' },
        overflowBehavior: { y: 'scroll', x: 'hidden' }
      }
    }
  },
  computed: {
    ...mapGetters ({ 
      currentCompany: "main/getCurrentCompany"
    }),
    projectsFiltered () {
      if (this.filterByName != '') {
        return this.options.filter(project => project.name.includes(this.filterByName))
      } else {
        return this.options
      }
    }
  },
  created () {
    this.setupData()
  },
  mounted () {
    this.osInstance = this.$refs.dropselectScrollBar.osInstance()
  },
  methods: {
    setupData () {
      this.selected = this.notSelectedItem
      if (this.customerId) {
        this.filters.company = this.customerId
      }
      this.getResults().then(() => {
        if (this.preselect) {
          const preselect_item = this.options.find(opt => opt.value == this.preselect)
          this.selectOption(preselect_item)
        }
      })
    },
    getResults () {
      return ProjectService.list(this.filters).then( (response) => {
        this.projectsList = response.data
        this.options.splice(0)
        this.projectsList.forEach(project => {
          this.options.push({ value: project.id, name: project.name })
        })
      })
    },
    selectOption (selected_item) {
      this.selected = selected_item
      this.$emit('selected-project', this.selected)
    },
    clearSearch () {
      this.filterByName = ''
      this.debouncedSearch()
      this.$refs.projectdropdown.show()
    }
  },
}
</script>

<style lang="scss" scoped>

</style>